import { GQL } from 'src/graphql';
import { AdapterFunc } from 'src/hooks/useEntityAdapter';
import { StatusModel } from '../models/status.model';

export const statusAdapter: AdapterFunc<GQL.StatusOutputDto, StatusModel> = (input) => ({
  id: input.id,
  name: input.name!,
  isDeletable: input.boolean!,
});
